import React from 'react';
import Button from 'components/UI/Button';
const FilterItem = props => {
    const style = {
      button: {
        fontSize: "18px",
        height: "40px",
        paddingRight:'30px'
      },
      wrapper: {
        width: "250px",
        position: "relative",
        margin: "10px 10px"
      },
      cross: {
        position: "absolute",
        right: "10px",
        top: "0px",
        bottom: "0px",
        fontSize: "20px",
        margin: "5px",
        verticalAlign: "middle",
        color: "#444445",
        cursor:'pointer'
      }
    };
    return (
      <div style={style.wrapper}>
        <Button type="holo" holo style={style.button}>
          {props.name}
        </Button>
        <p
          style={style.cross}
          onClick={() => {
            props.crossAction(props.name);
          }}
        >
          x
        </p>
      </div>
    );
  };
  export default FilterItem;